import React, { Component } from 'react';
import { Label } from 'semantic-ui-react'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';

class PlanControlTable extends Component {
  constructor(props){
    super(props);
    this.state = {
      translations: this.props.translations
    }

    const { preventative_controls, recovery_controls } = this.props.translations
    this.planColumns = [
      {
        dataField: 'preventative',
        text: preventative_controls,
        formatter: (cell, row)=>this.formatControl(cell, row),
        headerTitle: true,
        editable: false
      },
      {
        dataField: 'recovery',
        text: recovery_controls,
        headerTitle: true,
        editCellClasses: 'textarea-style',
        editable: false
      },
    ];
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      translations: nextProps.translations
    }, ()=>{
      const { preventative_controls, recovery_controls } = nextProps.translations;
      this.planColumns[0].text = preventative_controls;
      this.planColumns[1].text = recovery_controls;
      this.forceUpdate();
    })
  }

  formatControl = (control, row) => {
    return <div className="cell-style" key={control.id}>{ control.item.name }
            <div style={{ paddingLeft: '10px' }}>{this.formatTags(control.item.tag_list)}</div>
          </div>
  }

  formatTags = (tag_list) => {
    if(tag_list.length === 0) {
      return []
    }
    const tags = tag_list.map((tag, index) => {
        return <Label key={index}>{ tag }</Label>
    })
    return <div>{ this.state.translations.tags + ":"} {tags}</div>
  }

  parseControls = (controls) => {
    if(controls.length === 0) {
      return []
    }

    const preventative = controls.preventative.map((control, index) => {
        return { id: control.id, preventative: control }
    })

    return preventative
  }

  render() {
    const { controls, translations } = this.props;
    return (
      <BootstrapTable
        tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }}
        keyField="id"
        data={ this.parseControls(controls) }
        columns={ this.planColumns }
        striped
        hover
        condensed
        noDataIndication={<span className="no-data-indication"><i className="file alternate icon"></i>{translations.no_risk_selected}</span>}
      />
    )
  }
}

export default PlanControlTable;



// WEBPACK FOOTER //
// ./src/views/plan_tables/controls_table.js